import { inject, Injectable } from '@angular/core';
import { PRICE_CONFIG, PriceConfigToken } from '../_tokens/price-config.token';

@Injectable({
  providedIn: 'root'
})
export class PriceConfigService {
  private config = inject(PRICE_CONFIG, { optional: true }) as PriceConfigToken | undefined;

  private _dblCurrencyActivated = this.config?.dblCurrencyActivated ?? false;

  private conversionRate = this.config?.conversionRate ?? 1;
  private currencyIsocode = this.config?.currencyIsocode ?? 'EUR';
  private lang = this.config?.lang?.trim() ? this.config.lang : 'fr';

  private currencies = this.config?.currencies;

  get dblCurrencyActivated(): boolean {
    return this._dblCurrencyActivated;
  }

  set dblCurrencyActivated(val: boolean) {
    this._dblCurrencyActivated = val;
  }

  setConfig(
    dblCurrencyActivated: boolean,
    conversionRate: number,
    currencyIsocode: string,
    lang?: string,
    currencies?: Record<string, any>
  ) {
    this.config = {
      dblCurrencyActivated,
      conversionRate,
      currencyIsocode,
      lang,
      currencies
    };
    this.dblCurrencyActivated = this.config.dblCurrencyActivated ?? this.dblCurrencyActivated;
    this.conversionRate = this.config.conversionRate ?? this.conversionRate;
    this.currencyIsocode = this.config.currencyIsocode ?? this.currencyIsocode;
    this.lang = (this.config.lang && this.config.lang.trim() !== '') ? this.config.lang : this.lang;
    this.currencies = this.config.currencies ?? this.currencies;
  }

  getConversionInfo(sourceCurrencyIsocode: string): { rate: number; targetIsoCode: string } | null {
    const currencyIsocode = sourceCurrencyIsocode ?? this.currencyIsocode;
    if (this.currencies?.[currencyIsocode]) {
      const exchange = this.currencies[currencyIsocode].exchange;
      return {
        rate: typeof exchange.rate === 'string' ? parseFloat(exchange.rate) : exchange.rate,
        targetIsoCode: exchange.targetIsoCode
      };
    }

    if (!this.currencies && this.conversionRate && this.currencyIsocode) {
      return { rate: this.conversionRate, targetIsoCode: this.currencyIsocode };
    }

    return null;
  }

  getLang(): string {
    return this.lang;
  }

  getConversionRate(): number {
    return this.conversionRate;
  }
}
